import TableCellGroup from "ds/components/Table/Row/CellGroup";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PolicyTemplate } from "types/generated";

type PoliciesTemplatesTableNameCellProps = TableSimpleCellProps<PolicyTemplate> & {
  isExpanded: boolean;
  onToggle: () => void;
};

const PoliciesTemplatesTableNameCell = ({
  item: template,
  isExpanded,
  onToggle,
  ...cellProps
}: PoliciesTemplatesTableNameCellProps) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellGroup
        isActive
        isGroupOpen={isExpanded}
        onPress={onToggle}
        title={`Toggle ${template.name} body preview`}
      >
        <TableCellText>{template.name}</TableCellText>
      </TableCellGroup>
    </TableSimpleCell>
  );
};

export default PoliciesTemplatesTableNameCell;
